import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';
import { PerformanceReportingTrendsResponse } from '../_types';
import { generateTrends } from './performanceReportingDataGenerator';
import { useRiskPoolPerformanceReportingDemo } from '../../../../_data_sources/useRiskPoolPerformanceReportingDemo';

interface UseTrendsParams {
  orgId: string;
  childOrgId: string;
  assignedModule: string;
  startDate: string;
  endDate: string;
}

export default function useTrends(
  params: UseTrendsParams,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const useDemoData = useRiskPoolPerformanceReportingDemo();

  return useQuery<PerformanceReportingTrendsResponse, Error>(
    [
      'risk_pool_perf_report_trends',
      params.orgId,
      params.childOrgId,
      params.assignedModule,
      params.startDate,
      params.endDate,
    ],
    async (): Promise<PerformanceReportingTrendsResponse> => {
      try {
        if (useDemoData) {
          const demoData = generateTrends(params.childOrgId, params.assignedModule, params.startDate, params.endDate);
          console.log('[useTrends] Demo Data Response:', JSON.stringify(demoData, null, 2));
          return demoData;
        }

        const queryParams = createParamString({
          assignedModule: params.assignedModule,
          startDate: params.startDate,
          endDate: params.endDate,
        });
        const url = `${baseApiUrl()}/organizations/${params.orgId}/risk-pool/related-organizations/${params.childOrgId}/performance-reporting/trends?${queryParams}`;
        const data: PerformanceReportingTrendsResponse = await fetcher({
          method: 'get',
          url,
        });
        console.log('[useTrends] API Response:', JSON.stringify(data, null, 2));
        return data;
      } catch (err) {
        if (onError) onError(err as ServerErrorResponse);
        throw err;
      }
    },
    {
      ...options,
      enabled:
        !!params.orgId &&
        !!params.childOrgId &&
        !!params.assignedModule &&
        !!params.startDate &&
        !!params.endDate,
    }
  );
}

